import { __read } from 'tslib';
import { createContext } from '../utils/createContext.js';

/**
 * TableProvider
 *
 * Create context and provider for the Table components
 * This component is following the design pattern of @reach/menu-button
 *
 * @see Source   https://github.com/reach/reach-ui/tree/main/packages/menu-button
 *
 */
var _a = __read(createContext({
    name: "Table",
}), 2), useTableContext = _a[0], TableContext = _a[1];
TableContext.Consumer;
var TableProvider = TableContext.Provider;

export { TableProvider, useTableContext };
//# sourceMappingURL=TableProvider.js.map
